export const weight = {
  regular: 'var(--weight-regular)',
  medium: 'var(--weight-medium)',
  semibold: 'var(--weight-semibold)',
  bold: 'var(--weight-bold)',
} as const;

export type WeightToken = keyof typeof weight;
